import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import TextInput from "../../common/form/TextInput";
import FormRow from "../../common/form/FormRow";
import React, {useMemo} from "react";
import {Control} from "react-hook-form";

type Props = {
    index: number
    control: Control<any>
}


export const CallRecordingModeForm = ({ index, control }: Props) => {
    const { t } = useTranslation()

    const modeOptions = useMemo(
        () =>
            ['ALWAYS', 'ALWAYS_WITH_PAUSE_RESUME', 'ON_DEMAND', 'NEVER'].map(mode => ({
                value: `${mode}`,
                label: `${t(`call-recording.modes.${mode}`)}`,
            })),
        [t]
    )

    return (<FormRow>
        <FormFieldBox>
            <TextInput
                readonly={false}
                label={t('call-recording.mode')}
                name={`fieldUpdates.${index}.values.0.stringValue`}
                control={control}
                required={true}
                isRadio={true}
                options={modeOptions}
            />
        </FormFieldBox>
    </FormRow>)
}